module.exports = __webpack_public_path__ + "img/组20 1.653a22ff.png";